<template>
  <b-row>
    <b-col md="12">

      <!-- Alert: No item found -->
      <b-alert
        variant="danger"
        :show="errorMessage !== ''"
      >
        <h4 class="alert-heading">
          {{ errorMessage }}
        </h4>

      </b-alert>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class=""
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Tên phòng thu"
            rules="required"
          >
            <b-form-group>
              <template #label>
                <label class="d-block font-weight-bolder">Tên phòng thu <span class="text-danger">*</span></label>
              </template>
              <b-form-input
                id="name"
                v-model="itemData.studio_name"
                :disabled="true"
                :state="getValidationState(validationContext)"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Chon thiết bị -->
          <validation-provider
            #default="validationContext"
            :name="$t('Chọn thiết bị ')"
            rules="required"
          >
            <b-form-group label-for="country_id">
              <template #label>
                <label class="d-block font-weight-bolder">Chọn thiết bị <span class="text-danger">*</span></label>
              </template>
              <v-select
                v-model="itemData.device_ids"
                :options="dataDevices"
                :reduce="(val) => val.id"
                label="name"
                multiple
                placeholder="--Chọn--"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!--  Nội dung -->
          <validation-provider
            #default="validationContext"
            :name="$t('Nội dung sửa')"
            rules="required"
          >
            <b-form-group
              :label="$t('Nội dung')"
              label-for="title"
            >
              <template #label>
                <label class="d-block font-weight-bolder">Nội dung sửa <span class="text-danger">*</span></label>
              </template>
              <b-form-textarea
                id="content"
                v-model="itemData.content"
                :state="getValidationState(validationContext)"
                rows="3"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              <span v-if="mdata.id > 0">{{ $t('Update') }}</span>
              <span v-else>{{ $t('Save') }}</span>
            </b-button>
          </div>

        </b-form>
      </validation-observer>

    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BAlert, BOverlay, BForm, BFormGroup, BButton, BFormInput, BFormInvalidFeedback, BFormCheckbox, BFormTextarea, BCardText, BFormSelect,
} from 'bootstrap-vue'
import {
  ref,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNumDot, max,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import vSelect from 'vue-select'
import moment from 'moment'

export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BCardText,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    flatPickr,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    mdata: Object,
  },
  data() {
    return {
      required,
      alphaNumDot,
      max,
      dataManufacture: [],

    }
  },
  computed: {

  },
  mounted() {
  },
  methods: {

  },

  setup(props, { emit }) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const errorMessage = ref('')
    const dataDevices = ref([])
    const defaultItemData = {
      name: '',
      description: '',
      manufacture_id: '',
      plan_date: '',
      borrow_begin_date: '',
      studio_name: '',
      device_ids: [],
    }
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)));
    if (props.mdata) {
      dataDevices.value = props.mdata.data_devices.map(o => ({
        name: o.device_name,
        id: o.device_id,
      }));

      // dataDevices.value = props.mdata.details.map(o => ({
      //   name: o.series_name,
      //   id: o.series_id,
      // }));
      itemData.value = props.mdata;
      itemData.value.device_ids = props.mdata.data_devices.map(o => o.device_id);
    }
    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)

    const onSubmit = () => {
      errorMessage.value = '';

      if (itemData.value.id != null) {
        store.dispatch('studio/updateOneRepair', { data: itemData.value, id: itemData.value.id })
          .then((response) => {
            if (response.status === 200) {
              if (response.data.code === 200) {
                showToast(response.data.message, { variant: 'success' });
                resetForm()
                emit('updateData')
              } else {
                showToast(response.data.message)
                errorMessage.value = response.data.message;
              }
            }
          })
      }
    }

    const configDate = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    return {
      id,
      errorMessage,
      itemData,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      configDate,
      dataDevices,
    }
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
